import { State as AppServerState } from "../core/AppServer";
import { PaneDataByDataId } from "../stores/PaneDataStore";
import BaseService from "./BaseService";

export interface OnDialogOpenResponse {
  appServerState: AppServerState;
  paneDataByDataId: PaneDataByDataId;
}

export default class SimpleResultsGridControlService {
  public static async onDialogOpen(
    rowKey: string,
    dataId: string,
    widgetName: string,
    dialogRowKey: string
  ): Promise<OnDialogOpenResponse> {
    return BaseService.requestObject<OnDialogOpenResponse>(
      `SimpleResultsGridControl/OnDialogOpen/${rowKey}/${dataId}/${widgetName}`,
      null,
      null,
      {
        dialogRowKey,
      },
      "POST"
    );
  }
}
